import Papaparse from "papaparse";
import { DateTime } from "luxon";

const calculatePreviousSundays = (numberOfPreviousSundays) => {
  const today = DateTime.now().startOf("day");

  let sundays = [];
  let cursor = today;

  while (sundays.length < numberOfPreviousSundays) {
    if (cursor.weekday === 7) {
      // Sunday
      sundays.push(cursor.toFormat("yyyy-MM-dd"));
    }
    cursor = cursor.minus({ days: 1 });
  }

  return sundays;
};

const mapData = (data) => {
  const checkins = data.data.map((checkin) => {
    const firstName = checkin["[Checked in] First Name"];
    const lastName = checkin["[Checked in] Last Name"];
    const gender = checkin["[Checked in] Gender"];

    return {
      personId: `${firstName}-${lastName}-${gender}`
        .replace(" ", "-")
        .toLowerCase()
        .trim(),
      firstName,
      lastName,
      date: DateTime.fromFormat(checkin["Event Date"], "LLLL d, yyyy").toFormat(
        "yyyy-MM-dd"
      ),
      session: checkin["Session"],
    };
  });

  // Deduplicate people by personId
  const peopleMap = new Map();
  checkins.forEach((checkin) => {
    if (!peopleMap.has(checkin.personId)) {
      peopleMap.set(checkin.personId, checkin);
    }
  });
  const people = Array.from(peopleMap.values());

  const peopleWithCheckins = people.map((person) => {
    const personCheckins = checkins.filter(
      (checkin) => checkin.personId === person.personId
    );

    return {
      personId: person.personId,
      firstName: person.firstName,
      lastName: person.lastName,
      checkins: personCheckins
        .map((checkin) => ({
          date: checkin.date,
          session: checkin.session,
        }))
        .sort((a, b) => DateTime.fromISO(b.date) - DateTime.fromISO(a.date)),
    };
  });

  return { people: peopleWithCheckins, checkins };
};

export const processData = (csvString) => {
  const data = Papaparse.parse(csvString, {
    header: true,
    skipEmptyLines: true,
  });

  const { people, checkins } = mapData(data);

  const regularAttendees = people.filter(
    (person) => person.checkins.length >= 4
  );

  // Find the last 3 Sundays
  const sundays = calculatePreviousSundays(3);

  // Find regular attendees who have NOT checked in on any of the last 3 Sundays
  const inactiveRegulars = regularAttendees
    .filter((person) => {
      // Get all checkin dates for this person
      const checkinDates = person.checkins.map((c) => c.date);
      // Check if none of the last 3 Sundays are in their checkin dates
      return !sundays.some((sunday) => checkinDates.includes(sunday));
    })
    .map((person) => {
      const weeksSinceLastCheckin = Math.floor(
        DateTime.now().diff(DateTime.fromISO(person.checkins[0].date), "weeks")
          .weeks
      );

      return {
        ...person,
        session: person.checkins[0].session,
        weeksSinceLastCheckin,
      };
    });

  return { inactiveRegulars, people, checkins, sundays };
};
